// extracted by mini-css-extract-plugin
module.exports = {"WatchTime":"WatchTime_WatchTime__2OSsB"};